<template>
  <div :class="['content']" :style="`background: ${template.color}; color: ${template.textColor || '#fff'};`">
    <Marquee :template="template" />
    <div class="text">{{ text }}</div>

    <div :class="['img', showSmall, overflow]">
      <Qr :code="template.qrcode"/>
    </div>
    <div :class="['logo logo3', logoShow]"><img :src="template.logo" width="100%"></div>
  </div>
</template>

<script>
import Qr from '../template1/Qr.vue'
import Marquee from './marquee.vue';
export default {
  props: ['template'],
  components: {Qr, Marquee},
  data: () => ({
    logoShow: '',
    showSmall: '',
    overflow: '',
    text: "",
    stopWrite: false
  }),
  computed:{
    originalText(){
      return 'Aponte a câmera do seu celular para o código QR abaixo e confira a reportagem completa!'
    }
  },
  methods: {
    async write() {
      let total = this.originalText.length;
      while (total) {
        this.text += this.originalText[this.originalText.length - total];
        total--;
        await this.timeout(window.configs.timeWrite);
      }
      await this.timeout(window.configs.timeStage2)
      this.$emit('end')
    },
    timeout(time) {
      return new Promise((resolve) => setTimeout(resolve, time || 1000));
    },
  },
  mounted() {
    setTimeout(()=>this.showSmall='show-small',50)
    setTimeout(()=>{
      this.logoShow = 'logo-show'
      this.overflow='overflow'
      }, 1000)
    this.write();
  },
};
</script>

<style  scoped>

.content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fb611c;
  font-size: 47pt;
  font-family: tn;
}

.content *{
  transition: all .5s ease;
}

.logo{
  position: absolute;
  width: 400px;
  height: 300px;
  text-align: center;
  transition: all 1s ease;
  opacity: 0;
}

.logo-show{
  opacity: 1;
}

.logo3{
  bottom: 250px;
  left: 340px;
  width: 400px;
  height: 200px;
}

.text {
  top: 80px;
  padding:220px;
  text-align: center;
  font-size: 40pt;
  position: absolute;
  line-height: 100px;
  font-weight: bold;
}

.img {
  position: absolute;
  height: 0px;
  width: 0px;
  left: 240px;
  top: 800px;
  transform: translate(0, 0);
  animation: wave 10s infinite linear;
  overflow: hidden;
  /* transition: all 0.5s; */
  background: #fff;
  /* border-radius: 100% 30% 80% 50%; */
}

.show-small{
  height: 600px;
  width: 600px;
}

.overflow{
  overflow: initial
}

@keyframes wave {
  0% {
    border-radius: 60% 80% 80% 50%;
  }

  20% {
    border-radius: 100% 50% 50% 80%;
  }

  40% {
    border-radius: 30% 70% 10% 70%;
  }

  60% {
    border-radius: 88% 50% 80% 50%;
  }

  80% {
    border-radius: 60% 80% 90% 100%;
  }

  100% {
    border-radius: 60% 80% 80% 50%;
  }
}
</style>